import React, { useMemo } from 'react';
import { useTracking } from '@podiumhq/tracking';

import { FormElementWrapperWithAccountExists } from 'components/FormElements';
import SuggestedEmailMessage from 'components/Trials/components/FormFields/SuggestedEmailMessage';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useEventListener from 'hooks/useEventListener';

import useSuggestEmail from '../../hooks/useSuggestEmail';

import TrialFormField from './TrialFormField';

const EmailField = ({
  isSubmitting,
  listenForIframeEmailMessage = true,
  placeholder = 'Email',
  ...props
}) => {
  const { handleEmailSuggestion, spellCheckEmail, suggestedEmail } =
    useSuggestEmail();
  const { trackEvent } = useTracking();
  const {
    accountInfoFieldProps,
    checkEmailAddressExists,
    email,
    emailExists,
    checkForInvite,
    setEmail,
  } = useTrialsContext() || {};

  const isInIframe = window !== window?.parent;
  const handleEmailOnBlur = (email) => {
    checkForInvite(email);
    checkEmailAddressExists(email).then(() => spellCheckEmail(email));
  };

  const iframeEmailHandler = (event = {}) => {
    const emailFromMessage = event.data?.email;

    if (emailFromMessage?.length > 0) {
      setEmail && setEmail(emailFromMessage);

      trackEvent &&
        trackEvent('trials.accountInfo.emailFieldFilled', {
          email: emailFromMessage,
          origin: 'marketing page',
        });

      handleEmailOnBlur(emailFromMessage);
    }
  };

  useEventListener({
    eventName: 'message',
    handler:
      listenForIframeEmailMessage && isInIframe ? iframeEmailHandler : null,
  });

  const inputProps = useMemo(
    () => ({
      ...accountInfoFieldProps,
      disabled: isSubmitting,
      ...props,
    }),
    [accountInfoFieldProps, isSubmitting, props]
  );

  return (
    <>
      <FormElementWrapperWithAccountExists
        fieldExists={emailExists}
        fieldName="email"
      >
        <TrialFormField
          customOnBlur={handleEmailOnBlur}
          fieldName="email"
          id="trial-email"
          isUserProperty
          placeholder={placeholder}
          setFieldValue={setEmail}
          trackError
          value={email}
          variant="outline"
          {...inputProps}
        />
      </FormElementWrapperWithAccountExists>

      <SuggestedEmailMessage
        color="#c8cfd9"
        handleEmailSuggestion={handleEmailSuggestion}
        mb="24px"
        mt={!!suggestedEmail ? '-16px' : '0'}
        suggestedEmail={suggestedEmail}
      />
    </>
  );
};

export default EmailField;
